// extracted by mini-css-extract-plugin
export var container = "_7n-0";
export var containerTopRight = "_7n-1";